import React from "react";
import Modal from "./modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import cookie from "react-cookies";
import { VAS_BASE_URL, WEB_BASE_URL, UNIFIED_BASE_URL } from "../../webbase";
class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userEmail: cookie.load("user"),
      token: cookie.load("token"),
      users: [],
      users2: [],
      selectedDealer: "topupbox",
    };
    console.log(this.state.token);
    this.onInviteUser = this.onInviteUser.bind(this);
    this.getUsers = this.getUsers.bind(this);
    this.onChangeRole = this.onChangeRole.bind(this);
    this.onFundUser = this.onFundUser.bind(this);
    this.getDealers = this.getDealers.bind(this);
  }

  onInviteUser(event) {
    event.preventDefault();
    if (this.state.formEmail !== "" && this.state.formRole !== "") {
      toast.success("User Role Edited!!!");
    } else {
      toast.error("User Role Edit failed!!!");
    }
  }

  onFundUser(amount, user) {
    //event.preventDefault();
    const id = toast.loading("Please wait...");
    const data = {
      amount: amount,
      beneficiaryUsername: user,
    };
    console.log(data);
    fetch(WEB_BASE_URL + "/admin/direct-funding", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.state.token,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        if (res.status === "2000") {
          toast.update(id, {
            render: "Successfully funded User",
            type: "success",
            isLoading: false,
          });
          this.props.navigate("/");
        } else {
          toast.update(id, {
            render: res.description,
            type: "error",
            isLoading: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //get all users
  getUsers() {
    axios
      .get(
        VAS_BASE_URL +
          "/bills/get-all-users?dealerId=" +
          this.state.selectedDealer,
        {
          headers: {
            authorization: this.state.token,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        this.setState({
          users: res.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getDealers() {
    axios
      .post(
        // _BASE_URL + "/onboarding/all-merchants",
        {},
        {
          headers: {
            authorization: this.state.token,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        if (res.data.status === "2000") {
          this.setState({
            users2: res.data.data.data,
          });

          // this.getTransactions();
        } else {
          toast.error(res.data.description);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //set state for formRole
  onChangeRole(event) {}

  componentDidMount() {
    this.getUsers();
    this.getDealers();
  }
  componentDidUpdate(prevProps, prevState) {
    // Check if merchantEmail has changed
    if (prevState.selectedDealer !== this.state.selectedDealer) {
      this.getUsers();
    }
  }
  render() {
    return (
      <main className="page-content">
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
          <div className="ps-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0 p-0">
                <li className="breadcrumb-item">
                  <a href="javascript:;">
                    <i className="bx bx-home-alt"></i>
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  All Users
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <h5 className="mb-0">All Users in Vas</h5>
              <form className="ms-auto position-relative">
                <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                  <i className="bi bi-search"></i>
                </div>
                <input
                  className="form-control ps-5"
                  type="text"
                  placeholder="search"
                />
              </form>
              <div className="row">
                {/* <div className="col-4">
                  <button
                    style={{ marginTop: 29 }}
                    className="btn btn-primary d-flex"
                  >
                    <div>
                      <i class="bi bi-cloud-arrow-down-fill"></i>
                    </div>
                    <div className="mx-3">Download Report</div>
                  </button>
                </div> */}
              </div>
            </div>
            {/* <div className="col-lg-3 col-6 mt-4 col-md-3">
              <select
                className="form-select"
                value={this.state.selectedDealer}
                onChange={(event) => {
                  this.setState({
                    selectedDealer: event.target.value,
                  });
                }}
              >
                {this.state.users2.map((user, index) => (
                  <option key={index} value={user?.businessEmail}>
                    {user?.businessName}
                  </option>
                ))}
              </select>
            </div> */}
            <div className="table-responsive mt-3">
              <table className="table align-middle">
                <thead className="table-secondary">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone Number</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.users.map((user, index) => (
                    <>
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <div className="d-flex align-items-center gap-3 cursor-pointer">
                            <img
                              src="assets/images/dummy.png"
                              className="rounded-circle"
                              width="44"
                              height="44"
                              alt=""
                            />
                            <div className="">
                              <p className="mb-0">
                                {user?.firstName} {user?.lastName}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td>{user?.emailAddress}</td>
                        <td>{user?.phoneNumber}</td>
                        <td>{user?.status}</td>
                        <td>
                          <div className="table-actions d-flex align-items-center gap-3 fs-6">
                            <a
                              href="javascript:;"
                              className="text-danger"
                              data-bs-toggle="tooltip"
                              data-bs-placement="bottom"
                              title="Deactivate"
                            >
                              <i className="bi bi-x-circle-fill"></i>
                              Deactivate
                            </a>
                          </div>
                        </td>
                      </tr>
                      <Modal
                        title="Fund User"
                        id={"editModal" + index}
                        buttonText="Add funds"
                        onSubmit={this.onFundUser}
                        onChangeEmail={this.onChangeEmail}
                        onChangeRole={this.onChangeRole}
                        formEmail={user?.emailAddress}
                      ></Modal>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default Users;
